<template>
  <cognitive-block class="cc-logo-side-panel">
    <CCLogo />
  </cognitive-block>
</template>

<script>
import CCLogo from '@/assets/images/cognitive-credit-compressed.svg'
export default {
  name: 'LogoSidePanel',
  components: {
    CCLogo,
  },
}
</script>

<style lang="scss">
.cc-logo-side-panel {
  position: relative;
  overflow: hidden;

  svg {
    fill: $jungle-green;
    width: auto;
    height: 100%;
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 0;
    transform: rotate(25deg) translateY(-25%) translateX(-50%);
  }
}
</style>
